<template>
  <chart-shell :title="title" :info="chartConfig.info">
    <div>
      <div class="line-chart" :style="{ height: `${height}px` }" :id="title"></div>
    </div>
  </chart-shell>
</template>

<script>
import ChartShell from "@c/m11b-report-detail/sleep-chart/chart-shell.vue";
import { DateTool } from "@js/date-tool.js";
import { Line } from "@antv/g2plot";
import { SleepChartTool } from "@c/m11b-report-detail/sleep-chart/sleep-chart-tool.js";
import { number } from "echarts";


export default {
  components: {
    ChartShell,
  },

  props: {
    title: String,
    dataArray: Array,
    timeTickArray: Array,
    height: {
      type: Number,
      default: 190,
    },
  },

  data() {
    return {
      chartConfig: {
        info: "",
        yMin: 0,
        yMax: 0,
        yTickCount: 0,
        tooltipTitle: "",
        tooltipUnit: "",

      },
      lineChart: null, // 存储图表实例
      originalValueMap: new Map(), // 存储原始值的映射

    };
  },

  mounted() {
    this.configureChart();
  },

  watch: {
    dataArray: {
      handler(newData) {
        this.$nextTick(() => {
          this.configureChart();
        });
      },
      immediate: true
    }
  },

  beforeDestroy() {
    // 组件销毁前清理图表实例
    if (this.lineChart) {
      this.lineChart.destroy();
      this.lineChart = null;
    }
  },

  methods: {
    configureChart() {
      // 即使数据为空也要显示图表框架

      switch (this.title) {
        case "中枢型呼吸暂停":
          this.chartConfig = {
            info: "持续时间(s)",
            tooltipTitle: "中枢型呼吸暂停",
            tooltipUnit: "秒",
          };
          break;
        case "阻塞型呼吸暂停":
          this.chartConfig = {
            info: "持续时间(s)",
            tooltipTitle: "阻塞型呼吸暂停",
            tooltipUnit: "秒",
          };
          break;
        case "混合型呼吸暂停":
          this.chartConfig = {
            info: "持续时间(s)",
            tooltipTitle: "混合型呼吸暂停",
            tooltipUnit: "秒",
          };
          break;
        case "氧减事件(秒)":

          this.chartConfig = {
            info: "持续时间(s)",
            tooltipTitle: "氧减事件(秒)",
            tooltipUnit: "秒",
          };
          break;
        case "低通气":

          this.chartConfig = {
            info: "持续时间(s)",

            tooltipTitle: "低通气",
            tooltipUnit: "秒",
          };
          break;
        case "微觉醒":

          this.chartConfig = {
            info: "持续时间(s)",
            tooltipTitle: "微觉醒",
            tooltipUnit: "秒",
          };
          break;
        case "血氧饱和度":
          this.chartConfig = {
            info: "血氧(%)",
            yMin: 40,
            yMax: 100,
            yTickCount: 7,
            tooltipTitle: "血氧",
            tooltipUnit: "%",
          };
          break;

        case "脉率":
          this.chartConfig = {
            info: "脉率(次/分)",
            yMin: 0,
            yMax: 100,
            yTickCount: 7,
            tooltipTitle: "脉率",
            tooltipUnit: "bpm",
          };

          break;

        case "睡眠呼吸趋势":
          this.chartConfig = {
            info: "呼吸率(次/分)",
            yMin: 0,
            yMax: 40,
            yTickCount: 5,
            tooltipTitle: "呼吸",
            tooltipUnit: "bpm",
          };
          break;
        case "睡眠分期趋势":
          this.chartConfig = {
            info: "",
            yMin: 0,
            yMax: 4,
            yTickCount: 5,
            tooltipTitle: "呼吸",
            tooltipUnit: "bpm",
          };
          break;
        case "睡眠呼吸事件":
          this.chartConfig = {
            info: "持续时间(s)",
            tooltipTitle: "持续时间",
            tooltipUnit: "秒",
          };
          break;
        case "体位图":
          this.chartConfig = {
            info: "体位",
            yMin: 0.5,
            yMax: 4.5,
            yTickCount: 4,
            tooltipTitle: "体位",
            tooltipUnit: "",
          };
          break;
        default:
          break;
      }
      this.renderChart();
    },

    renderChart() {
      // 如果已存在图表实例，先销毁
      if (this.lineChart) {
        this.lineChart.destroy();
        this.lineChart = null;
      }

      // 确保容器存在
      const container = document.getElementById(this.title);
      if (!container) {
        return;
      }

      // 清空容器内容
      container.innerHTML = '';

      // 定义需要显示为垂直线的图表类型
      const verticalLineCharts = ["微觉醒", "中枢型呼吸暂停", "阻塞型呼吸暂停", "混合型呼吸暂停", "低通气", "氧减事件(秒)"];

      // 如果数据为空，使用空数组
      let chartData = this.dataArray && this.dataArray.length > 0 ? this.dataArray : [];




      // 为微觉醒和呼吸事件创建垂直线效果
      if (verticalLineCharts.includes(this.title) && chartData.length > 0) {


        // 清空并重新填充原始值映射
        this.originalValueMap.clear();
        chartData.forEach(item => {

          this.originalValueMap.set(item.xValue, item.yValue);
        });

        const verticalLineData = [];
        chartData.forEach(item => {
          // 添加起点（y=0）
          verticalLineData.push({
            xValue: item.xValue,
            yValue: 0
          });
          // 添加终点（实际值）
          verticalLineData.push({
            xValue: item.xValue,
            yValue: item.yValue
          });
          // 添加断点（null）来分隔每条垂直线
          verticalLineData.push({
            xValue: item.xValue,
            yValue: null
          });
        });
        chartData = verticalLineData;

      }


      this.lineChart = new Line(this.title, {
        //数据
        data: chartData,
        xField: "xValue",
        yField: "yValue",
        connectNulls: this.title === "睡眠呼吸趋势" && !verticalLineCharts.includes(this.title),
        meta: {
          xValue: {
            type: "time",
            alias: "时间",
            mask: "HH:mm",
            tickMethod: () => {
              return this.timeTickArray;
            },
          },
        },
        //x轴
        xAxis: {
          line: {
            style: {
              stroke: "#333",
            },
          },
          tickLine: {
            style: {
              stroke: "#333",
            },
          },
        },
        //y轴
        yAxis: {
          min: this.chartConfig.yMin,
          max: this.chartConfig.yMax,
          tickCount: this.chartConfig.yTickCount,
          nice: true, // 让刻度更美观
          label: {
            formatter: (item) => {
              switch (this.title) {
                case "睡眠分期趋势":
                  return SleepChartTool.sleepPeriodStatusToStr(item);
                case "体位图":
                  return this.positionToStr(item);
                case "脉率":
                case "血氧饱和度":
                  return Math.round(item); // 确保显示整数
                default:
                  return item;
              }
            },
          },
          grid: {
            line: {
              style: {
                stroke: '#f0f0f0',
                lineWidth: 1,
                lineDash: [4, 5],
              },
            },
          },
          line: {
            style: {
              stroke: "#333",
            },
          },
          tickLine: {
            style: {
              stroke: "#333",
            },
          },
        },
        //折线
        color: "#DC143C",
        lineStyle: {
          lineWidth: 0.8,
        },
        point: false,
        legend: {
          layout: "horizontal",
          position: "right",
        },
        tooltip: {
          showContent: this.title != "睡眠呼吸事件",
          showTitle: this.title != "睡眠分期趋势" || "睡眠呼吸",
          formatter: (item) => {
            switch (this.title) {
              case "睡眠分期趋势":
                return {
                  name: DateTool.millisecondTimestampToStr(item.xValue, "h:m"),
                  value: SleepChartTool.sleepPeriodStatusToStr(
                    `${item.yValue}`
                  ),
                };
              case "体位图":
                return {
                  name: DateTool.millisecondTimestampToStr(item.xValue, "h:m"),
                  value: this.positionToStr(item.yValue),
                };
              default:
                // 对于垂直线图表，从映射中获取原始值
                let value;
                if (verticalLineCharts.includes(this.title) && this.originalValueMap.has(item.xValue)) {
                  value = this.originalValueMap.get(item.xValue);
                } else {
                  value = item.yValue ? item.yValue : 0;
                }

                return {
                  name: this.chartConfig.tooltipTitle,
                  value: `${value}${this.chartConfig.tooltipUnit}`,
                };
            }
          },
        },
      });
      this.lineChart.yAxis = {};
      this.lineChart.render();
    },

    positionToStr(position) {
      const pos = Math.round(position);
      switch (pos) {
        case 5:
          return "立";
        case 4:
          return "右";
        case 3:
          return "左";
        case 2:
          return "仰";
        case 1:
          return "俯";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.line-chart {
  width: 100%;
  // height: rem(190);
  box-sizing: border-box;
  padding: 0 rem(25);
  margin-top: rem(10);
  margin-bottom: rem(10);
}
</style>
